<div class="nav-tabs">
  <div class="nav-item">
    <a class="nav-link cursor-pointer" (click)="typeChange.emit(DiscoverCardType.Latest)" [class.active]="type === DiscoverCardType.Latest">
      {{ 'discover.card.nav.latest' | transloco }}
    </a>
  </div>
  <div class="nav-item">
    <a
      class="nav-link cursor-pointer"
      (click)="typeChange.emit(DiscoverCardType.Megatrends)"
      [class.active]="type === DiscoverCardType.Megatrends"
    >
      {{ 'discover.card.nav.megatrends' | transloco }}
    </a>
  </div>
  <div class="nav-item">
    <a
      class="nav-link cursor-pointer"
      (click)="typeChange.emit(DiscoverCardType.KnowHow)"
      [class.active]="type === DiscoverCardType.KnowHow"
    >
      {{ 'discover.card.nav.know-how' | transloco }}
    </a>
  </div>
  <div class="nav-item">
    <a class="nav-link cursor-pointer" (click)="typeChange.emit(DiscoverCardType.More)" [class.active]="type === DiscoverCardType.More">
      {{ 'discover.card.nav.more' | transloco }}
    </a>
  </div>
</div>
